import ApiGuideFuneralInvitationPage from "@/views/apiGuide/ApiGuideFuneralInvitationPage.vue";
import PaymentModalApiPage from '@/views/apiGuide/PaymentModalApiPage.vue';

const apiInvitationRoutes = [
  {
    path: "/company",
    children: [
      {
        path: "invitation/info/:orderNum",
        name: "ApiGuideFuneralInvitationPage",
        components: {
          default: ApiGuideFuneralInvitationPage,
        },
        props: {
          default: true,
        },
      },
      {
        path: 'invitation/:orderNum',
        name: 'PaymentModalApiPage',
        components: {
          default: PaymentModalApiPage,
        },
        props: {
          default: true,
        },
      },
    ],
  },
]

export default apiInvitationRoutes;